import type { RootState } from '@store';
import { createSelector } from 'reselect';

export const cartSelector = (state: RootState) => state.cart;

export const productsTotalSelector = createSelector(
  [cartSelector],
  (cart) => ({
    productsTotal: cart.products.reduce((acc, product) => acc + product.qty, 0),
  }),
);

export const promoSelector = createSelector(
  [cartSelector],
  (cart) => ({
    promoCode: cart.promoCode,
    promoError: cart.promoError,
    isPromoLoading: cart.isPromoLoading,
  }),
);

export const errorProductsSelector = createSelector(
  [cartSelector],
  (cart) => {
    return {
      mergedProducts: cart.mergedProducts,
      removedProducts: cart.removedProducts,
      marketRestrictedProducts: cart.marketRestrictedProducts,
    };
  },
);

export const isZeroQtyOrderSelector = createSelector([cartSelector], (cart) => cart.products.some((p) => p.qty === 0));
